import React from "react";
import ManagementPanel from "../components/ManagementPanel";

function ManagementPage({ rows, userRole }) {
  return <ManagementPanel rows={rows} userRole={userRole} />;
}

export default ManagementPage;

